export const environment = {
  production: false,
  couchUrl: 'https://euroclean.clicr-test.fr/couch/euroclean',
  pouchDbName: 'euroclean-stag',
  backUrl: 'https://euroclean.clicr-test.fr'
};
